export default __webpack_public_path__ + "Redirect_Peas_Transparent.1c24a283dac0deece854.png";